<template>
  <el-drawer
    :model-value="modelValue"
    title="模板与导出"
    size="1280px"
    class="template-center-drawer"
    @update:model-value="emit('update:modelValue', $event)"
    @open="handleOpen"
  >
    <ExportTemplateCenterPanel
      ref="panelRef"
      :project-code="projectCode"
      :project="resolvedProject"
      :admin-users="adminUsers"
      :projects="projects"
      @export-started="emit('export-started', $event)"
    />
  </el-drawer>
</template>

<script setup>
import { ref, computed } from 'vue'
import ExportTemplateCenterPanel from './ExportTemplateCenterPanel.vue'

const props = defineProps({
  modelValue:  { type: Boolean, default: false },
  projectCode: { type: String,  default: null },
  project:     { type: Object,  default: null },
  adminUsers:  { type: Array,   default: () => [] },
  projects:    { type: Array,   default: () => [] }
})

const emit = defineEmits(['update:modelValue', 'export-started'])

const panelRef = ref(null)

const resolvedProject = computed(() => {
  if (props.project?.id) return props.project
  if (!props.projectCode) return null
  return props.projects.find((p) => p.code === props.projectCode) || null
})

function handleOpen() {
  panelRef.value?.refresh?.()
}
</script>

<style>
.template-center-drawer .el-drawer__body {
  padding: 16px 20px;
  height: calc(100% - 55px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.template-center-drawer .template-center {
  flex: 1;
  min-height: 0;
}
</style>
